import React from 'react';
import { Text } from 'react-native-elements';
import i18n from 'i18n-js';

export const AccountBalancesScreen = () => (
    <Text style={{ marginTop: 250, textAlign: 'center' }}>
        {i18n.t('common.comingSoon')}
    </Text>
);
